import { api } from './api';

// Todos os endpoints exigem platform_admin (roleMiddleware no backend).
// includeStore: false porque admin opera cross-tenant.

export const adminService = {
  getStats: async (filters = {}) => {
    const qs = new URLSearchParams();
    ['from', 'to', 'storeId'].forEach((k) => {
      if (filters[k] !== undefined && filters[k] !== '') qs.set(k, filters[k]);
    });
    const s = qs.toString();
    return api.get(`/api/admin/stats${s ? `?${s}` : ''}`, { includeStore: false });
  },

  listStores: async (filters = {}) => {
    const qs = new URLSearchParams();
    ['status', 'businessType', 'planType', 'q'].forEach((k) => {
      if (filters[k] !== undefined && filters[k] !== '') qs.set(k, filters[k]);
    });
    if (filters.isBlocked !== undefined && filters.isBlocked !== '') {
      qs.set('isBlocked', filters.isBlocked);
    }
    if (filters.includeInactive) qs.set('includeInactive', 'true');
    if (filters.page) qs.set('page', filters.page);
    if (filters.limit) qs.set('limit', filters.limit);
    const s = qs.toString();
    return api.get(`/api/admin/stores${s ? `?${s}` : ''}`, { includeStore: false });
  },

  getStore: async (storeId) =>
    api.get(`/api/admin/stores/${storeId}`, { includeStore: false }),

  updateStoreStatus: async (storeId, status) =>
    api.patch(`/api/admin/stores/${storeId}/status`, { status }, { includeStore: false }),

  blockStore: async (storeId) =>
    api.patch(`/api/admin/stores/${storeId}/block`, null, { includeStore: false }),

  unblockStore: async (storeId) =>
    api.patch(`/api/admin/stores/${storeId}/unblock`, null, { includeStore: false }),

  deactivateStore: async (storeId) =>
    api.patch(`/api/admin/stores/${storeId}/deactivate`, null, { includeStore: false }),

  activateStore: async (storeId) =>
    api.patch(`/api/admin/stores/${storeId}/activate`, null, { includeStore: false }),

  // Cria store + associa/cria owner user. Payload aceita
  // { ...storeFields, owner: { userId } | { email, name, phone?, cpf? } }.
  // Se owner não existe, backend cria user novo e dispara email de reset.
  createStore: async (payload) =>
    api.post('/api/admin/stores', payload, { includeStore: false }),

  listUsers: async (filters = {}) => {
    const qs = new URLSearchParams();
    ['status', 'role', 'q', 'storeId'].forEach((k) => {
      if (filters[k] !== undefined && filters[k] !== '') qs.set(k, filters[k]);
    });
    if (filters.active !== undefined && filters.active !== '') qs.set('active', filters.active);
    if (filters.page) qs.set('page', filters.page);
    if (filters.limit) qs.set('limit', filters.limit);
    const s = qs.toString();
    return api.get(`/api/admin/users${s ? `?${s}` : ''}`, { includeStore: false });
  },

  getUser: async (userId) =>
    api.get(`/api/admin/users/${userId}`, { includeStore: false }),

  createUser: async (payload) =>
    api.post('/api/admin/users', payload, { includeStore: false }),

  updateUser: async (userId, payload) =>
    api.patch(`/api/admin/users/${userId}`, payload, { includeStore: false }),

  updateUserStatus: async (userId, payload) =>
    api.patch(`/api/admin/users/${userId}/status`, payload, { includeStore: false }),

  resetUserPassword: async (userId) =>
    api.post(`/api/admin/users/${userId}/reset-password`, null, { includeStore: false }),

  // Vínculo user ↔ store: REVITER admin liga/desliga reseller (e outros) de
  // qualquer loja. DB suporta M:N nativamente via storeUsers.
  linkUserToStore: async (userId, payload) =>
    api.post(`/api/admin/users/${userId}/stores`, payload, { includeStore: false }),

  updateUserStoreRole: async (userId, storeId, payload) =>
    api.patch(`/api/admin/users/${userId}/stores/${storeId}`, payload, { includeStore: false }),

  unlinkUserFromStore: async (userId, storeId) =>
    api.delete(`/api/admin/users/${userId}/stores/${storeId}`, { includeStore: false })
};

export default adminService;
